import { useQuery } from "@tanstack/react-query";
import { Button, Card, Col, Descriptions, Flex, Image, Modal, Row, Typography } from "antd";
import { Link, useParams } from "react-router";
import { surveyService } from "../../services/survey.service";
import { Icon } from "@iconify/react/dist/iconify.js";
import pallete from "../../utils/pallete";
import { useState } from "react";
import { API_BASE_URL } from "../../config/api.config";

export default function CanceledDocumentAnalysisDetail(){

  const { id } = useParams()

  const [previewImage, setPrevieImage] = useState('')

  const { data: surveyData } = useQuery({
    queryKey: ['detailCanceledDataSurvey', id],
    queryFn: () => surveyService.getRejectedDataById(id)
  })

  const registration = surveyData?.data?.acceptance?.registration

  return (
    <>
      <Card
        title="Informasi Cancel"
        style={{ marginBottom: 20 }}
      >
        <Descriptions
          column={1}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          items={[
            { label: 'Cancel By', children: surveyData?.data?.rejection?.rejectedBy?.name },
            { label: 'Alasan Cancel', children: surveyData?.data?.rejection?.reason },
          ]}
        />
      </Card>
      <Card
        title="Detail Data Tercancel"
      >
        <Descriptions
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          style={{ marginBottom: 20 }}
          title="Informasi Pelanggan"
          items={[
            { label: 'Nama Pelanggan', children: surveyData?.data?.nama },
            { label: 'No Telepon', children: surveyData?.data?.telepon },
            { label: 'Email', children: surveyData?.data?.email },
            { label: 'Kota', children: surveyData?.data?.kota },
            { label: 'Kecamatan', children: surveyData?.data?.kecamatan },
            { label: 'Kelurahan', children: surveyData?.data?.kelurahan },
            { label: 'Jalan', children: surveyData?.data?.jalan },
            { span: 0.5, label: 'No Rumah', children: surveyData?.data?.no_rumah },
            { span: 0.5, label: 'RT', children: surveyData?.data?.rt?.toString().padStart(3,'0') },
            { span: 0.5, label: 'RW', children: surveyData?.data?.rw?.toString().padStart(3,'0') },
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Titik Lokasi Koordinat"
          items={[
            { label: 'Titik Lokasi Koordinat', children: surveyData?.data?.lokasi_bangunan },
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Lokasi"
          items={[
            { label: 'PA/PC',  children: surveyData?.data?.ab?.PAPC_CODE },
            { label: 'BLOK/EZ', span: 0.5, children: surveyData?.data?.ab?.AREA == 'WEST' ? surveyData?.data?.ab?.BLOCKNO : surveyData?.data?.ab?.EZ_CODE },
            { label: 'NOVAK/BLOK', span: 0.5, children: surveyData?.data?.ab?.NOVAK },
            { label: 'Sumber air lain yang digunakan pelanggan', span: 2, children: surveyData?.data?.sumber_lain },
            { label: 'Jaringan Pipa', children: surveyData?.data?.jaringan_pipa },
            { label: 'Jarak bangunan dengan pipa existing PAM JAYA', children: surveyData?.data?.jarak_bangunan_dengan_pipa },
            { label: 'Ukuran Pipa Input ', children: surveyData?.data?.ukuran_pipa },
            { label: 'Diameter Pipa Dinas yang akan dipasang', children: surveyData?.data?.diameter_pipa },
            { label: 'Jenis jalan/gailan', children: surveyData?.data?.jenis_jalan },
            { label: 'Perlu crosing jalan', children: surveyData?.data?.perlu_crossing_jalan },
            { label: 'Lebar Jalan', children: surveyData?.data?.lebar_jalan },
            { label: 'Perlu crossing saluran air', children: surveyData?.data?.perlu_crossing_air },
            { label: 'Panjang casing pipa', children: surveyData?.data?.panjang_casing_pipa },
            { label: 'Halaman', children: surveyData?.data?.halaman },
            { label: 'Sanitasi', span: 0.5, children: surveyData?.data?.sanitasi },
            { label: 'Saluran Pembuangan', span: 0.5, children: surveyData?.data?.saluran_pembuangan },
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Bangunan"
          items={[
            { label: 'Kamar Tidur',  children: surveyData?.data?.kamar_tidur },
            { label: 'Kamar Mandi',  children: surveyData?.data?.kamar_mandi },
            { label: 'Ruang Tamu',  children: surveyData?.data?.ruang_tamu },
            { label: 'Ruang Makan',  children: surveyData?.data?.ruang_makan },
            { label: 'Ruang Keluarga',  children: surveyData?.data?.ruang_keluarga },
            { label: 'Dapur',  children: surveyData?.data?.dapur },
            { label: 'Teras',  children: surveyData?.data?.teras },
            { label: 'Garasi',  children: surveyData?.data?.garasi },
            { label: 'Gudang/Paviliun',  children: surveyData?.data?.gudang },
            { label: 'Lantai',  children: surveyData?.data?.jumlah_lantai },
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={1}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Dokumen"
          items={[
            { 
              label: 'KTP', 
              children: (
                <Flex gap={8} >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.ktp}</Typography.Text>
                  <Button 
                    icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                    disabled={!registration?.ktp}
                  >
                    <Link to={registration?.ktp && `${API_BASE_URL}/files/registration/${registration?.ktp}`} >
                      Unduh
                    </Link>
                  </Button>
                  <Button 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                    icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.ktp}`)}
                    disabled={!registration?.ktp}
                  >
                    Lihat
                  </Button>
                  
                </Flex>
              )
            },
            { 
              label: 'KK', 
              children: (
                <Flex gap={8} >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.kk}</Typography.Text>
                  <Button 
                    icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                    disabled={!registration?.kk}
                  >
                    <Link to={registration?.kk && `${API_BASE_URL}/files/registration/${registration?.kk}`} >
                      Unduh
                    </Link>
                  </Button>
                  <Button 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                    icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.kk}`)}
                    disabled={!registration?.kk}
                  >
                    Lihat
                  </Button>
                  
                </Flex>
              )
            },
            { 
              label: 'PBB', 
              children: (
                <Flex gap={8} >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.pbb}</Typography.Text>
                  <Button 
                    icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                    disabled={!registration?.pbb}
                  >
                    <Link to={registration?.pbb && `${API_BASE_URL}/files/registration/${registration?.pbb}`} >
                      Unduh
                    </Link>
                  </Button>
                  <Button 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                    icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.pbb}`)}
                    disabled={!registration?.pbb}
                  >
                    Lihat
                  </Button>
                  
                </Flex>
              )
            },
            { 
              label: 'Bangunan', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.bangunan}</Typography.Text>
                  <Button 
                    icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                    disabled={!registration?.bangunan}
                  >
                    <Link to={registration?.bangunan && `${API_BASE_URL}/files/registration/${registration?.bangunan}`} >
                      Unduh
                    </Link>
                  </Button>
                  <Button 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                    icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.bangunan}`)}
                    disabled={!registration?.bangunan}
                  >
                    Lihat
                  </Button>
                </Flex>
              )
            },
            { 
              label: 'Surat Pelayanan', 
              children: (
                <Flex gap={8} >
                  <Typography.Text style={{ marginRight: 'auto' }}>{surveyData?.data?.serviceLetter?.fileName}</Typography.Text>
                  <Button 
                    icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                  >
                    <Link to={surveyData?.data?.serviceLetter?.fileName && `${API_BASE_URL}/files/registration/${surveyData?.data?.serviceLetter?.fileName}`} >
                      Unduh
                    </Link>
                  </Button>
                  <Button 
                    onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${surveyData?.data?.serviceLetter?.fileName}`)}
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                    icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    disabled={!surveyData?.data?.serviceLetter?.filePath}
                  >
                    Lihat
                  </Button>
                  
                </Flex>
              )
            },
            ...surveyData?.data?.additionalLetter?.map(
              (e,i) => ({
                label: i == 0 ? 'Dokumen Pendukung' : '',
                children: (
                  <Flex gap={8} >
                    <Typography.Text style={{ marginRight: 'auto' }}>{e?.fileName}</Typography.Text>
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                    >
                      <Link to={e?.filename && `${API_BASE_URL}/files/registration/${e?.filename}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${e?.filename}`)}
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      disabled={!e?.fileName}
                    >
                      Lihat
                    </Button>
                    
                  </Flex>
                )
              })
            ) ?? []
          ]}
        />
        <Typography.Title level={5} >
          Persetujuan
        </Typography.Title>
        <Row>
          <Col span={12} >
            <Flex vertical align="center" >
              <Image
                src={surveyData?.data?.tanda_tangan_pelanggan}
                preview={false}
              />
              <Typography.Text>
                {surveyData?.data?.nama}
              </Typography.Text>
              <Typography.Text style={{ color: pallete.primary.main }} >
                Pelanggan
              </Typography.Text>
            </Flex>
          </Col>
          <Col span={12} >
            <Flex vertical align="center" >
              <Image
                src={surveyData?.data?.tanda_tangan_surveyor}
                preview={false}
              />
              <Typography.Text>
                {surveyData?.data?.acceptance?.surveyor?.name}
              </Typography.Text>
              <Typography.Text style={{ color: pallete.primary.main }} >
                Surveyor
              </Typography.Text>
            </Flex>
          </Col>
        </Row>
      </Card>
      <Modal
        open={previewImage.length > 0}
        centered
        title="Gambar"
        onCancel={()=> setPrevieImage('')}
        footer={[
          <Button variant="outlined" color="primary" key="cancel" onClick={() => setPrevieImage('')}>
            Cancel
          </Button>
        ]}
      >
        <Image src={previewImage} />
      </Modal>
    </>
  ) 
}